  // translation for backwards compatibility with OCSA
  export const getDomainType = (domainType: string, call2tenls: boolean) => {
    switch (domainType) {
      case 'LIGHT_WEIGHT_DOMAIN': return call2tenls ? domainType : 'LightWeightDomain';
      default:
        return call2tenls ? 'DEFAULT_DOMAIN' : 'DefaultDomain';
    }
  };